module.exports = __webpack_public_path__ + "static/sample_donut-965ed3817ce7a175fe216d0241d4d318.png";